import axios from 'axios'
import router from './router'
import {
  Notification,
  MessageBox
} from 'element-ui'
import {
  baseurl
} from './base.js';
let Tigger = false;
axios.interceptors.response.use((res) => {
  Tigger && Tigger.close();
  if (res.data.status) {
    if (res.data.status == 'success') {
      return Promise.resolve(res.data);
    } else {
      for (let i = 0, len = res.data.errors.length; i < len; i++) {
        if (res.data.errors[i].errcode == 3002) {
          MessageBox.alert('您的账户已被停用，如需继续使用请联系网联商务客服人员：400-800-3588，点击确定按钮，返回登录页面', '', {
            confirmButtonText: '确定',
            showClose: false,
          }).then(() => {
            axios.defaults.headers.post['tokenId'] = '';
            localStorage.setItem("tokenId", '')
            router.push({
              path: '/login'
            })
          })
        } else {
          let str = res.data.errors[i].tip || res.data.errors[i].errmsg || "系统错误"
          Tigger = Notification.error({
            title: '错误',
            message: str
          });
        }
        if (res.data.errors[i].errcode == 7008) {
          axios.defaults.headers.post['tokenId'] = '';
          localStorage.setItem("tokenId", '')
          router.push({
            path: '/login'
          })
          break;
        }
      }
      return Promise.reject(res.data);
    }
  } else {
    if (res.data.code == 200) {
      return Promise.resolve(res.data);
    } else {
      Notification.error({
        title: '错误',
        message: res.data.desc
      });
      if (res.data.code == 403) {
        axios.defaults.headers.post['tokenId'] = '';
        localStorage.setItem("tokenId", '')
        router.push({
          path: '/login'
        })
      }
      return Promise.reject(res.data);
    }
  }

}, (error) => {
  //404等问题可以在这里处理
  Notification.error({
    title: '错误',
    message: error.message
  });
  return Promise.reject(error);
});
axios.defaults.baseURL = baseurl;
axios.defaults.timeout = 60000;
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
if (!!localStorage.getItem("tokenId")) {
  axios.defaults.headers.common['tokenId'] = localStorage.getItem("tokenId");
}
export default axios;



// WEBPACK FOOTER //
// ./src/httpjs.js